import { Product, WTFIRInputType, WTFIRTypeData } from "@src/api";

export class PairService {
  public static sourceIsRfid(source: WTFIRInputType) {
    return source === WTFIRInputType.rfid;
  }

  public static sourceIsBarcode(source: WTFIRInputType) {
    return source === WTFIRInputType.barcode;
  }

  public static prepareCIS(data: string) {
    return data.split(/\\u001d|\u001d]/g).at(0);
  }

  public static scanTypeCorrect(source: WTFIRInputType, scanType: WTFIRTypeData, additionalTypes: WTFIRTypeData[] = []) {
    const isRfid = this.sourceIsRfid(source);
    
    const isEpc = scanType === WTFIRTypeData.epc;
    const isCis = scanType === WTFIRTypeData.cis;
    const isQr = scanType === WTFIRTypeData.qr;

    return (isRfid ? isEpc : isCis || isQr) || additionalTypes.includes(scanType);
  }

  public static isEpcClear(scanType: WTFIRTypeData) {
    return scanType === WTFIRTypeData.epcClear;
  }

  /**
   * Проверяет, является ли товар немаркированным
   * @param typeData - тип данных, полученный от WTFIR
   * @param product - объект товара
   * @returns true, если товар немаркированный, иначе false
   */
  public static isNonMarked(typeData: WTFIRTypeData, product: Product) {
    // Если тип данных - КИЗ, то товар 100% маркированный
    return typeData === WTFIRTypeData.cis ? false : product.is_marked === false;
  }
};
